module.exports = __webpack_public_path__ + "img/lipscomb-logo.be0d53ec.png";